import { oauth_store } from 'src/types'

const store: oauth_store = {
  logged: false,
  already_logged: false,
}

export default store
